import React from "react";
import { FluentIconsProps, wrapIcon } from ".";
import appleCalendarIcon from "../assets/apple_calendar_icon.jpg";

export const PortalFacebookIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="24px"
      width="24px"
      role="presentation"
      focusable="false"
      viewBox="0 0 30 30"
      {...props}
    >
      <path
        d="M30 15.091C30 6.756 23.285 0 15 0S0 6.756 0 15.091C0 22.625 5.484 28.868 12.656 30V19.454H8.848V15.09h3.808v-3.324c0-3.782 2.239-5.872 5.666-5.872 1.64 0 3.358.295 3.358.295v3.714h-1.893c-1.863 0-2.443 1.164-2.443 2.358v2.83h4.16l-.665 4.362h-3.495V30C24.516 28.868 30 22.625 30 15.091z"
        fill="#1877f2"
      ></path>
    </svg>
  );
}, "PortalFacebookIcon");

export const PortalTwitterIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="24px"
      width="24px"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <path
          d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"
          fill="#1D9BF0"
        ></path>
      </g>
    </svg>
  );
}, "PortalTwitterIcon");

export const PortalLinkedInIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="24px"
      width="24px"
      role="presentation"
      focusable="false"
      viewBox="2 2 16 16"
      {...props}
    >
      <rect
        x="2.08301"
        y="2.08301"
        width="15.8333"
        height="15.8333"
        rx="2"
        fill="#0077B5"
      ></rect>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.9797 5.57329C6.9797 4.79429 6.34485 4.16211 5.5645 4.16211C4.78069 4.16211 4.14844 4.79429 4.14844 5.57329C4.14844 6.35315 4.78069 6.98534 5.5645 6.98534C6.34485 6.98534 6.9797 6.35315 6.9797 5.57329ZM12.9989 7.86069C15.4707 7.86069 15.9271 9.48174 15.9271 11.5907V15.8856H13.4865L13.4857 11.8722C13.4774 11.0027 13.3781 10.0016 12.2185 10.0016C10.948 10.0016 10.754 10.9914 10.754 12.0131V15.8856H8.31678V8.05501H10.6561V9.12506H10.6899C11.0147 8.50929 11.8115 7.86069 12.9989 7.86069ZM6.78601 8.05508V15.8857H4.34276V8.05508H6.78601Z"
        fill="white"
      ></path>
    </svg>
  );
}, "PortalLinkedInIcon");

export const PortalGithubIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg role="presentation" focusable="false" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"
      ></path>
    </svg>
  );
}, "PortalGithubIcon");

export const PortalGoogleCalendarIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="16px"
      width="16px"
      role="presentation"
      focusable="false"
      viewBox="186 38 76 76"
      {...props}
    >
      <path fill="#fff" d="M244 56h-40v40h40V56z" />
      <path fill="#EA4335" d="M244 114l18-18h-18v18z" />
      <path fill="#FBBC04" d="M262 56h-18v40h18V56z" />
      <path fill="#34A853" d="M244 96h-40v18h40V96z" />
      <path fill="#188038" d="M186 96v12c0 3.315 2.685 6 6 6h12V96h-18z" />
      <path fill="#1967D2" d="M262 56V44c0-3.315-2.685-6-6-6h-12v18h18z" />
      <path
        fill="#4285F4"
        d="M244 38h-52c-3.315 0 -6 2.685-6 6v52h18V56h40V38z"
      />
      <path
        fill="#4285F4"
        d="M212.205 87.03c-1.495-1.01-2.53-2.485-3.095-4.435l3.47-1.43c.315 1.2.865 2.13 1.65 2.79.78.66 1.73.985 2.84.985 1.135 0 2.11-.345 2.925-1.035s1.225-1.57 1.225-2.635c0-1.09-.43-1.98-1.29-2.67-.86-.69-1.94-1.035-3.23-1.035h-2.005V74.13h1.8c1.11 0 2.045-.3 2.805-.9.76-.6 1.14-1.42 1.14-2.465 0 -.93-.34-1.67-1.02-2.225-.68-.555-1.54-.835-2.585-.835-1.02 0 -1.83.27-2.43.815a4.784 4.784 0 0 0 -1.31 2.005l-3.435-1.43c.455-1.29 1.29-2.43 2.515-3.415 1.225-.985 2.79-1.48 4.69-1.48 1.405 0 2.67.27 3.79.815 1.12.545 2 1.3 2.635 2.26.635.965.95 2.045.95 3.245 0 1.225-.295 2.26-.885 3.11-.59.85-1.315 1.5-2.175 1.955v.205a6.605 6.605 0 0 1 2.79 2.175c.725.975 1.09 2.14 1.09 3.5 0 1.36-.345 2.575-1.035 3.64s-1.645 1.905-2.855 2.515c-1.215.61-2.58.92-4.095.92-1.755.005-3.375-.5-4.87-1.51zM233.52 69.81l-3.81 2.755-1.905-2.89 6.835-4.93h2.62V88h-3.74V69.81z"
      />
    </svg>
  );
}, "PortalGoogleCalendarIcon");

export const PortalAppleCalendarIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="16px"
      width="16px"
      role="presentation"
      focusable="false"
      viewBox="2 2 20 20"
      {...props}
    >
      <rect width="20" height="20" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_16469_164331" transform="scale(0.0025)" />
        </pattern>
        <image
          id="image0_16469_164331"
          width="400"
          height="400"
          xlinkHref={appleCalendarIcon}
        />
      </defs>
    </svg>
  );
}, "PortalAppleCalendarIcon");

export const PortalMicrosoft365Icon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="16px"
      width="16px"
      role="presentation"
      focusable="false"
      viewBox="0 0 64 64"
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1{isolation:isolate;}.cls-2{opacity:0.2;}.cls-2,.cls-3,.cls-5{mix-blend-mode:multiply;}.cls-4{fill:#fff;}.cls-5{opacity:0.12;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:none;}"
          }
        </style>
        <linearGradient
          id="linear-gradient"
          x1="45.2"
          y1="-1.42"
          x2="45.2"
          y2="57.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffb900" />
          <stop offset="0.17" stopColor="#ef8400" />
          <stop offset="0.31" stopColor="#e25c01" />
          <stop offset="0.43" stopColor="#db4401" />
          <stop offset="0.5" stopColor="#d83b01" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="34.52"
          y1="0.67"
          x2="3.16"
          y2="45.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#800600" />
          <stop offset="0.6" stopColor="#c72127" />
          <stop offset="0.73" stopColor="#c13959" />
          <stop offset="0.85" stopColor="#bc4b81" />
          <stop offset="0.94" stopColor="#b95799" />
          <stop offset="1" stopColor="#b85ba2" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="18.5"
          y1="55.63"
          x2="59.44"
          y2="55.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f32b44" />
          <stop offset="0.6" stopColor="#a4070a" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="35.16"
          y1="-0.24"
          x2="28.52"
          y2="9.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopOpacity="0.4" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1="46.32"
          y1="56.55"
          x2="27.99"
          y2="54.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopOpacity="0.4" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g className="cls-1">
        <g id="Icons_-_Color" data-name="Icons - Color">
          <g id="Desktop_-_Full_Bleed" data-name="Desktop - Full Bleed">
            <g className="cls-2">
              <image
                className="cls-3"
                width="177"
                height="70"
                transform="translate(15.18 48.78) scale(0.24)"
                xlinkHref="data:image/png;base64,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"
              />
              <path
                className="cls-4"
                d="M19.93,49a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81A6,6,0,0,0,34.48,62l17.09-4.87A6.12,6.12,0,0,0,56,51.26V49Z"
              />
            </g>
            <g className="cls-5">
              <image
                className="cls-3"
                width="169"
                height="61"
                transform="translate(16.11 48.51) scale(0.24)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAAA+CAYAAAC7gYDXAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEeklEQVR4Xu2dzW7bRhhFDy0ZWqQIDBhpF44Bp7s0azcxsu4D9EGLPkDQ7oIm7dZBd2kB1wvXcCEYbQBFotnFN2OOSIqiZPFH1D2AQNMitTq4c4e/UZIkCNF1hss2KCKKogG272DZtkI8gBiYJUkSR1UTNZBzH3gMHLmlZBV1EANj4E9gvDRRnaAj4ACT8xA4Bk7d+tLfEGINJsA58ANwXipZFEX7mJjPgG+Al5ikh6SJurfwB4RYn09u+RMwWCiqk/Qr4Az4DngBnGBy7qOOKupnhHOsUNRA0tfA98Ar4Em4oxBNkhO1QNLXbn0/u60QTTHXL93E6RAb7iWp6AzZidAI+BrrpK+QpKIj3Ivq0vQAeI5NnJ4gSUVHCBN1hM3qz9xyVLC9EK2wB7k0fe7+1uxedAafqEPgKXZA/wSlqegYXtQBOn8vOkzYUfewZNUpUdEF7oCZW0pK0Uli4Ba4dMtYooouMgP+An5zy5lEFV1kLlGTJFGiik5yB3x2n1xHnSuvQrRErp9CKmrhl0K0QK6fQiqq//I9do/KJL+/EI0wBf4BLnD9FJyobmUM/O4+Y5Sqonn8yH6ByTr1X4QddYKl6S8oVUU7eAffEwz7EIiaSdUPwDWB0ULUTG5U98M+5M9MTYCPwBvgHXCFZBXNUDqiz90zlSRJHEXRjdvYS6wb+0TdTLER/AMFaQoFN/clSTKNougKeIsdU70lvVX6AAkrNssUG7nfYSP5RwrmRwsf6VPw8Ikz7KLqEySs2Axe0rfAj255lSRJrm6WPnsq8zifE0zUM0zcZ5jIuq9KrENlSWGJqPcb5YV9gd2p+i3qr2J1VpIUKj7gzBXbT1EUTbBDCJduOUb9VazGypJCxUTNov4q1iDGJknX2MSpsqSwpqig/ipWYgrcAH9gj5J8gx0CrSQpPEBUj/qrWECMnQL1kv6KCXqOCXtTVVKo2FHLUH8VAaGc/rLRG+xM08+YrNfAJHtAfxkPTtQs6q87xyI5L7BrSi+C9ZVSNGTjooL6a8/xYsakZy4XyekvxJ/iXhpR9INVqEVUj/prbyhKzVtsFn9JTXKGPLijlqH+urVUSc1LTNRQ3I3KGVJromZRf+0066Tmnd+vDjlDGhUVSvurhG2WzqVmGY2L6tGEqxU6nZpltCaqRxOuWtmq1Cyj1slUFTTh2jhbm5pltJ6oWTThWpnepGYZnRMV1F8r0MvULKOTonrUX+/ZidQso/WOWsaO99edS80yOp2oWXreX3c+NcvYKlGhd/1VqVmRrRPVs6X9Vam5Jp3uqGVsUX9Vam6ArU3ULB3qr0rNGuiNqNDqBS9KzZrplaieCsI+xiZcQ9aTVqnZML0U1bNA2JfAMVYTjjBpw8dvDkjfYOhfwBGKFYqp1GyIXovqyQh7hEl6DJy6dT+pHJC+E/YR8B+pdF60GamYSs2G2AlRPU7YITbsF72keOj+dwp8CfxNKqR/THfMvJhKzQbYKVFDAmnDjrpHKvAXwL/MC+mRmA2zs6IuIhD4vqNKyPb5H2YSUSsF15tNAAAAAElFTkSuQmCC"
              />
              <path
                className="cls-4"
                d="M19.93,49a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81A6,6,0,0,0,34.48,62l17.09-4.87A6.12,6.12,0,0,0,56,51.26V49Z"
              />
            </g>
            <path
              className="cls-6"
              d="M34.41,2,39,12.5V49L34.48,62l17.09-4.87A6.12,6.12,0,0,0,56,51.26V12.74a6.11,6.11,0,0,0-4.44-5.88Z"
            />
            <path
              className="cls-7"
              d="M12.74,48.61l5-2.7A4.36,4.36,0,0,0,20,42.08V22.43a4.37,4.37,0,0,1,2.87-4.1L39,12.5V8.07A6.32,6.32,0,0,0,34.41,2a6.18,6.18,0,0,0-1.73-.24h0a6.41,6.41,0,0,0-3.14.83L11.08,13.12A6.1,6.1,0,0,0,8,18.42V45.78A3.21,3.21,0,0,0,12.74,48.61Z"
            />
            <path
              className="cls-8"
              d="M39,49H19.93a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81h0A6,6,0,0,0,34.48,62,6.22,6.22,0,0,0,39,56Z"
            />
            <path
              className="cls-9"
              d="M12.74,48.61l5-2.7A4.36,4.36,0,0,0,20,42.08V22.43a4.37,4.37,0,0,1,2.87-4.1L39,12.5V8.07A6.32,6.32,0,0,0,34.41,2a6.18,6.18,0,0,0-1.73-.24h0a6.41,6.41,0,0,0-3.14.83L11.08,13.12A6.1,6.1,0,0,0,8,18.42V45.78A3.21,3.21,0,0,0,12.74,48.61Z"
            />
            <path
              className="cls-10"
              d="M39,49H19.93a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81h0A6,6,0,0,0,34.48,62,6.22,6.22,0,0,0,39,56Z"
            />
            <rect className="cls-11" width="64" height="64" />
          </g>
        </g>
      </g>
    </svg>
  );
}, "PortalMicrosoft365Icon");

export const PortalOutlookIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="16px"
      width="16px"
      role="presentation"
      focusable="false"
      viewBox="2 2 16 16"
      {...props}
    >
      <path
        d="M17.8 9.52L11.5 5.92H11.41C11.3005 5.8427 11.1732 5.79453 11.04 5.78C10.9047 5.77891 10.7711 5.80974 10.65 5.87H10.56L4.25998 9.47C4.20058 9.50425 4.15156 9.55394 4.11811 9.6138C4.08466 9.67366 4.06803 9.74145 4.06998 9.81C4.06975 9.87571 4.08613 9.94042 4.1176 9.99811C4.14906 10.0558 4.1946 10.1046 4.24998 10.14L11.04 15L17.85 10.19C17.9066 10.1551 17.9536 10.1067 17.9868 10.0491C18.0199 9.99144 18.0382 9.92646 18.04 9.86C18.0362 9.78644 18.0116 9.71548 17.9691 9.65531C17.9266 9.59514 17.868 9.54822 17.8 9.52Z"
        fill="#0A2767"
      ></path>
      <path
        d="M16.04 2H6.04004C5.77482 2 5.52047 2.10536 5.33293 2.29289C5.1454 2.48043 5.04004 2.73478 5.04004 3L11.04 5L17.04 3C17.04 2.73478 16.9347 2.48043 16.7471 2.29289C16.5596 2.10536 16.3053 2 16.04 2Z"
        fill="#0364B8"
      ></path>
      <path d="M11 3H5V9L10.99 15.01H16.99V8.99L11 3Z" fill="#28A8EA"></path>
      <path d="M17 3H11V9H17V3Z" fill="#50D9FF"></path>
      <path d="M10.99 15.01L5 15V9H11L10.99 15.01Z" fill="#0078D4"></path>
      <path
        opacity="0.5"
        d="M11.04 15L4.20996 10.17L4.71996 9.29L11.04 12.87L17.32 9.28L17.81 10.19L11.04 15Z"
        fill="#0A2767"
      ></path>
      <path
        d="M17.81 10.19L11.5 13.78C11.3595 13.8697 11.1967 13.9183 11.03 13.92H10.97C10.887 13.9304 10.803 13.9304 10.72 13.92L13.04 17L17.68 17.83C17.7915 17.7483 17.8823 17.6414 17.9448 17.518C18.0074 17.3947 18.04 17.2583 18.04 17.12V9.85999C18.0342 9.9304 18.0099 9.99804 17.9695 10.056C17.9291 10.114 17.874 10.1602 17.81 10.19Z"
        fill="#1490DF"
      ></path>
      <path
        opacity="0.1"
        d="M12.04 13.48L11.5 13.79C11.3595 13.8798 11.1967 13.9283 11.03 13.93H10.97C10.887 13.9405 10.803 13.9405 10.72 13.93L13.04 17L17.68 17.83C17.7915 17.7483 17.8823 17.6414 17.9448 17.518C18.0074 17.3947 18.04 17.2583 18.04 17.12V16.85L12.04 13.48Z"
        fill="black"
      ></path>
      <path
        d="M4.17995 10.19C4.13193 10.1502 4.09415 10.0994 4.06979 10.042C4.04543 9.9846 4.0352 9.92218 4.03995 9.85999V17.13C4.04 17.3099 4.0958 17.4853 4.19967 17.6321C4.30354 17.779 4.45037 17.89 4.61995 17.95C4.71602 17.9651 4.81388 17.9651 4.90995 17.95H17.12C17.3026 17.9522 17.4813 17.8961 17.63 17.79L4.17995 10.19Z"
        fill="#28A8EA"
      ></path>
      <path
        opacity="0.5"
        d="M11.04 16C11.5705 16 12.0792 15.7893 12.4543 15.4142C12.8293 15.0391 13.04 14.5304 13.04 14V7C13.04 6.73478 12.9347 6.48043 12.7471 6.29289C12.5596 6.10536 12.3053 6 12.04 6H5.04004V9.07L4.25004 9.52C4.19344 9.55488 4.14643 9.60332 4.11325 9.66094C4.08008 9.71856 4.06179 9.78354 4.06004 9.85H4.04004V15.99L11.04 16Z"
        fill="black"
      ></path>
      <path
        d="M11 5H3C2.44772 5 2 5.44772 2 6V14C2 14.5523 2.44772 15 3 15H11C11.5523 15 12 14.5523 12 14V6C12 5.44772 11.5523 5 11 5Z"
        fill="#0078D4"
      ></path>
      <path
        d="M4.20009 8.36999C4.4433 7.87674 4.83032 7.46881 5.31009 7.19999C5.84108 6.91364 6.43691 6.76899 7.04009 6.77999C7.6126 6.7651 8.17872 6.90318 8.68009 7.17999C9.1589 7.42919 9.55238 7.81571 9.81009 8.28999C10.0679 8.79774 10.1983 9.36059 10.1901 9.92999C10.2022 10.5265 10.0684 11.117 9.80009 11.65C9.54295 12.1263 9.15414 12.5186 8.68009 12.78C8.15853 13.0617 7.57271 13.203 6.98009 13.19C6.39396 13.2018 5.8149 13.0605 5.30009 12.78C4.83481 12.5183 4.45336 12.1299 4.20009 11.66C3.94353 11.1589 3.81309 10.6029 3.82009 10.04C3.8144 9.46126 3.94456 8.88927 4.20009 8.36999ZM5.39009 11.1C5.51592 11.4124 5.73171 11.6804 6.01009 11.87C6.30578 12.066 6.65563 12.1639 7.01009 12.15C7.36504 12.1564 7.71364 12.0553 8.01009 11.86C8.28645 11.6707 8.4991 11.4023 8.62009 11.09C8.7527 10.7492 8.81725 10.3856 8.81009 10.02C8.8138 9.65222 8.75288 9.28667 8.63009 8.93999C8.51851 8.61009 8.30358 8.32493 8.01718 8.12679C7.73078 7.92865 7.38815 7.82808 7.04009 7.83999C6.68611 7.82999 6.33742 7.92763 6.04009 8.11999C5.75823 8.31096 5.53631 8.57796 5.40009 8.88999C5.24769 9.23983 5.17265 9.61846 5.18009 9.99999C5.16838 10.3776 5.24008 10.7532 5.39009 11.1Z"
        fill="white"
      ></path>
    </svg>
  );
}, "PortalOutlookIcon");

export const PortalPersonalWebsiteIcon = wrapIcon((props: FluentIconsProps) => {
  return (
    <svg
      height="20px"
      width="20px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      focusable="false"
      {...props}
    >
      <g>
        <path
          d="M4.52393 6.25C4.52393 5.83579 4.85971 5.5 5.27393 5.5H18.7297C19.1439 5.5 19.4797 5.83579 19.4797 6.25V9.75C19.4797 10.1642 19.1439 10.5 18.7297 10.5H5.27393C4.85971 10.5 4.52393 10.1642 4.52393 9.75V6.25ZM6.02393 7V9H17.9797V7H6.02393ZM14.2297 11.979C13.8155 11.979 13.4797 12.3148 13.4797 12.729V17.229C13.4797 17.6432 13.8155 17.979 14.2297 17.979H18.7297C19.1439 17.979 19.4797 17.6432 19.4797 17.229V12.729C19.4797 12.3148 19.1439 11.979 18.7297 11.979H14.2297ZM14.9797 16.479V13.479H17.9797V16.479H14.9797ZM4.52393 13.25C4.52393 12.8358 4.85971 12.5 5.27393 12.5H11.25C11.6642 12.5 12 12.8358 12 13.25C12 13.6642 11.6642 14 11.25 14H5.27393C4.85971 14 4.52393 13.6642 4.52393 13.25ZM5.27393 16C4.85971 16 4.52393 16.3358 4.52393 16.75C4.52393 17.1642 4.85971 17.5 5.27393 17.5H11.25C11.6642 17.5 12 17.1642 12 16.75C12 16.3358 11.6642 16 11.25 16H5.27393ZM2 5.75C2 4.23122 3.23122 3 4.75 3H19.25C20.7688 3 22 4.23122 22 5.75V18.25C22 19.7688 20.7688 21 19.25 21H4.75C3.23122 21 2 19.7688 2 18.25V5.75ZM4.75 4.5C4.05964 4.5 3.5 5.05964 3.5 5.75V18.25C3.5 18.9404 4.05964 19.5 4.75 19.5H19.25C19.9404 19.5 20.5 18.9404 20.5 18.25V5.75C20.5 5.05964 19.9404 4.5 19.25 4.5H4.75Z"
          fill="#5B5FC7"
        />
      </g>
    </svg>
  );
}, "PortalPersonalWebsiteIcon");
